import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { App, Button, Flex, Pagination, Table, Typography } from "antd"
import { APIService } from "../services/API.service";
import { Audience, AudienceGroup, AudienceGroupFilter, CreateAudience } from "../interfaces/Campaign.interface";
import { audienceToHumanReadableString } from "../utils/audience.utils";
import { useAuth } from "../hooks/useAuth";
import { AudienceCreator } from "../components/AudienceCreator";
import { CopyOutlined, EditOutlined } from "@ant-design/icons";
import { useState } from "react";
import { Mode } from "../interfaces/mode.type";
import ButtonGroup from "antd/es/button/button-group";

export const Audiences = (props: { applicationId: string}) => {
     // Access the client
     const queryClient = useQueryClient()
     const [currentAudience, setCurrentAudience] = useState<Audience|undefined>(undefined)
     const auth = useAuth()
     const audienceQuery = useQuery({ staleTime: 300000,queryKey: ['audience', props.applicationId], queryFn: () => auth.api.getAudiences(props.applicationId) })
     const tagsQuery = useQuery({ staleTime: 300000,queryKey: ['tags', props.applicationId], queryFn: () => auth.api.getTagsForApp(props.applicationId) })
     const { message } = App.useApp();
     const [currentAudienceMode, setCurrentAudienceMode] = useState<Mode>(Mode.New);
     
     const audienceMutation = useMutation({
        mutationFn: async (audience: CreateAudience) => await auth.api.createAudience(props.applicationId, audience),
        onSuccess: () => {
            // Invalidate and refetch
            queryClient.invalidateQueries({ queryKey: ['audience', props.applicationId] })
        },
        onError: () => {
            console.error("Oops we failed to create an Audience")
            message.error("Oops we failed to create an Audience");
        }
    })

    const createAudience = async (audience: CreateAudience) => {
        try {
            let newAudience = await audienceMutation.mutateAsync(audience);
            return newAudience;
        } catch (error) {
            // Re-throw the error so it's caught by the AudienceCreator component
            throw error;
        }
    }
    const handleAction = async (action:Mode,audience:Audience) => {
        switch(action)
        {
            case Mode.Edit:
                setCurrentAudienceMode(Mode.Edit);
                
                audience.audienceGroups = audience.audienceGroups.map(x=>{ 
                    return {type: x.type, filters: x.filters.map(f=>{
                        return {
                            type: f.type,
                            fieldName: f.fieldName,
                            string_value: f.string_value,
                            fileId: f.fileId,
                            file_dataUri: f.file_dataUri,
                            file: f.file,
                            num_value: f.num_value,
                        } as unknown as AudienceGroupFilter
                    })}
                }) as unknown as AudienceGroup[]
                setCurrentAudience({...audience});
                break;
            case Mode.Clone:
                setCurrentAudienceMode(Mode.Clone);

                let cloneSource = {
                    id: audience.id,
                    name: audience.name,
                    audienceGroups: audience.audienceGroups,
                    reach: audience.reach,
                    estimatedReach: audience.estimatedReach
                };
                cloneSource.audienceGroups = cloneSource.audienceGroups.map(x=>{ 
                    return {type: x.type, filters: x.filters.map(f=>{
                        return {
                            type: f.type,
                            fieldName: f.fieldName,
                            string_value: f.string_value,
                            fileId: f.fileId,
                            file_dataUri: f.file_dataUri,
                            file: f.file,
                            num_value: f.num_value,
                        } as unknown as AudienceGroupFilter
                    })}
                }) as unknown as AudienceGroup[]
                console.log("audienc", cloneSource);
                setCurrentAudience(cloneSource);
                break;
        }
    }

    const handleOnClose = async ()=> {
        setCurrentAudienceMode(Mode.New);
        setCurrentAudience(undefined);
    }

    const onDownloadAudienceFile = async (applicationId:string, audienceId?:string, fileId?:string, fileName?:string)=>{
        if(fileId && audienceId && fileName)
        {
            auth.api.downloadAudienceFile(applicationId, audienceId, fileId, fileName)
        }
        
    }
    
    return (
        <Flex vertical gap={10} style={{ maxHeight: '100%' }} wrap={"nowrap"}>

            <Flex justify="space-between" align="baseline">
                <Typography.Title level={3}>Segments</Typography.Title>
                <AudienceCreator operationMode={currentAudienceMode} applicationId={props.applicationId} saveAudience={ async (audience: CreateAudience) => await createAudience(audience)} initial={currentAudience} onClose={handleOnClose}/>
            </Flex>
            {(audienceQuery.data??[]).length > 0 && (tagsQuery.data??[]).length > 0 && (
                        <Table
                            
                            rowKey={'id'}
                            columns={
                                [
                                    { title: 'Name', dataIndex: 'name', key: 'name', render: (eventName:string, audience:Audience)=> audience.name},
                                    { title: 'Description', dataIndex: '.', key: 'desc', render: (eventName:string, audience:Audience)=> audienceToHumanReadableString(props.applicationId, audience,  tagsQuery.data ?? [], onDownloadAudienceFile)},
                                    { title: 'Est Reach', dataIndex: '.', key: 'reach', render: (eventName:string, audience:Audience)=> audience.estimatedReach},
                                    { title: 'Actions', dataIndex: '.', key: 'actions', render: (eventName:string, audience:Audience)=> (<Flex>          
                                        <ButtonGroup>
                                            <Button key="edit" title="Edit" onClick={()=>handleAction(Mode.Edit, audience)}><EditOutlined /></Button>
                                            <Button key="clone" title="Clone" onClick={()=>handleAction(Mode.Clone, audience)}><CopyOutlined /></Button>
                                        </ButtonGroup>
                                    </Flex>)},
                                ]
                            }
                            dataSource={audienceQuery.data ?? []}
                            >
                            
                        </Table>)}
        </Flex>
    )
}